import { useMemo } from 'react';
import { Row } from '@harmony/enablers/components/data-grid/data-grid';
import { TColumnData } from '../../shared-components/table-filters-panel';
import { useMEMTranslation } from '../../utils/text-utils';
import { EUserNotificationType, TUserNotification } from '../../ducks/api-ducks/user-notifications-duck/types-user-notifications';
import { useMonthDayYearWithDefaultTimeZone } from '../../utils/date-utils';

export const useNotificationsColumns = (): TColumnData[] => {
  const { t } = useMEMTranslation();
  return useMemo(
    () => [
      {
        field: 'notification',
        content: t('notificationsPanelColumnNotification'),
        display: {
          width: '60%',
        },
      },
      {
        field: 'notificationStatus',
        content: t('notificationsPanelColumnStatus'),
        sortable: true,
      },
      {
        field: 'notificationPostedDate',
        content: t('notificationsPanelColumnDate'),
        sortable: true,
      },
    ],
    [t]
  );
};

export const useNotificationsRows = (notifications: TUserNotification[]): Row<TUserNotification>[] => {
  const parseDate = useMonthDayYearWithDefaultTimeZone();
  return useMemo(
    () =>
      notifications.map((notification) => ({
        id: notification.notificationReferenceId || '',
        customData: notification,
        cells: {
          notification:
            notification.notificationType === EUserNotificationType.ActionCenter ? notification.message || '' : notification.richMessage || '',
          notificationStatus: notification.notificationStatus || '',
          notificationPostedDate: parseDate(notification.notificationStartDate || ''),
        },
      })),
    [notifications, parseDate]
  );
};
